import React from "react";
import { Box, Divider, Text, VStack } from "@chakra-ui/react";
import { Skeleton } from "@chakra-ui/react";

export function AdminCardSkeleton () {
  return (
    <>
      <Skeleton h='10rem' w='100%' />
      <Skeleton h='10rem' w='100%' />
      <Skeleton h='10rem' w='100%' />
    </>
  )
}

interface AdminType {
  admin: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    createdAt: string;
    updatedAt: string;
  }
}

const AdminCard: React.FC<AdminType> = ({ admin }) => {
  return (
    <Box w='100%'>
      <VStack bg='#f2f2f2' p='5' borderRadius='6' spacing={5}>
        <Box w='100%'>
          <Text fontWeight='semibold' color='gray.500'>
            First Name
          </Text>

          <Box mt='2'>
            <Text
              p='2' border='1px' borderRadius='5' borderColor='gray.500' color='gray.500'
              fontWeight='semibold'
            >
              {admin.firstName}
            </Text>
          </Box>
        </Box>

        <Box w='100%'>
          <Text fontWeight='semibold' color='gray.500'>
            Last Name
          </Text>

          <Box mt='2'>
            <Text
              p='2' border='1px' borderRadius='5' borderColor='gray.500' color='gray.500'
              fontWeight='semibold'
            >
              {admin.lastName}
            </Text>
          </Box>
        </Box>

        <Box w='100%'>
          <Text fontWeight='semibold' color='gray.500'>
            Email Address
          </Text>

          <Box mt='2'>
            <Text
              p='2' border='1px' borderRadius='5' borderColor='gray.500' color='gray.500'
              fontWeight='semibold'
            >
              {admin.email}
            </Text>
          </Box>
        </Box>

        <Box w='100%'>
          <Text fontWeight='semibold' color='gray.500'>
            Role
          </Text>

          <Box mt='2'>
            <Text
              p='2' border='1px' borderRadius='5' borderColor='gray.500' color='gray.500'
              fontWeight='semibold'
            >
              {admin.role}
            </Text>
          </Box>
        </Box>
      </VStack>

      <Divider mt='5' borderColor='gray.500' />
    </Box>
  )
}

export default AdminCard